const DEFAULTS =   {
  duration: 300,
  done: () => {},
};

let _options = {};

const isAnimatingStyle = {
  transition: 'opacity ease 500ms',
};

const outStyle = {
  opacity: 0,
};

export default function fadeOut(el, options) {
  _options = {...DEFAULTS, ...options};
  isAnimatingStyle.transition = `opacity ${_options.duration}ms ease`;
  _animateOut(el);
}

function _animateOut(el) {
  el.addEventListener('transitionend', _removeTransition);
  Object.assign(el.style, isAnimatingStyle);
  window.requestAnimationFrame(() => {
    Object.assign(el.style, outStyle);
  });
}

function _removeTransition(e) {
  if (e.currentTarget !== e.target) {
    return;
  }

  Object.assign(e.target.style, {
    transition: '',
    display: 'none',
  });
  e.target.removeEventListener('transitionend', _removeTransition);
  _options.done();
}
